module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称:"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.companyChange
    },
    model: {
      value: (_vm.filters.companyId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyId", $$v)
      },
      expression: "filters.companyId"
    }
  }, _vm._l((_vm.companies), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域:"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.groupChange
    },
    model: {
      value: (_vm.filters.groupId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "groupId", $$v)
      },
      expression: "filters.groupId"
    }
  }, _vm._l((_vm.groups), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称:"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.deviceId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "deviceId", $$v)
      },
      expression: "filters.deviceId"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期:"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择时间",
      "align": "right"
    },
    model: {
      value: (_vm.filters.date),
      callback: function($$v) {
        _vm.$set(_vm.filters, "date", $$v)
      },
      expression: "filters.date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.filters.date,
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "row_table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.logs,
      "border": ""
    },
    on: {
      "expand": _vm.expandChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": props.row.lineTimeList,
            "border": "",
            "highlight-current-row": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "header-align": "center",
            "align": "center",
            "label": "离线时间",
            "formatter": _vm.formatTime,
            "min-width": "250"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "header-align": "center",
            "align": "center",
            "label": "上线时间",
            "formatter": _vm.formatTime2,
            "min-width": "250"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "header-align": "center",
            "align": "center",
            "label": "离线时长",
            "formatter": _vm.formatDuration,
            "min-width": "250"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "deviceNo",
      "label": "设备ID",
      "width": "250"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "name",
      "label": "设备名称",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "offlineCount",
      "label": "离线次数",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "formatter": _vm.formatDuration2,
      "label": "总离线时长",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "disabled": scope.row.offlineCount <= 0 || scope.row.disposed
          },
          on: {
            "click": function($event) {
              _vm.handleAdd(scope.$index, scope.row)
            }
          }
        }, [_vm._v("原因提交")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提交原因",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设备ID",
      "prop": "deviceNo"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.addForm.deviceNo),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "deviceNo", $$v)
      },
      expression: "addForm.deviceNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "事件时间",
      "prop": "eventDate"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.addForm.eventDate),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "eventDate", $$v)
      },
      expression: "addForm.eventDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "掉线类型",
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.addForm.type),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "type", $$v)
      },
      expression: "addForm.type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客服姓名",
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "5"
    },
    model: {
      value: (_vm.addForm.customerName),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "customerName", $$v)
      },
      expression: "addForm.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": "5",
      "maxlength": "300"
    },
    model: {
      value: (_vm.addForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "remark", $$v)
      },
      expression: "addForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16ec0245"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/DeviceStatus.vue
// module id = 1298
// module chunks = 1